import React from 'react';
import styled from '@emotion/styled';
import useIntersectionAnimate from '../../../hooks/useIntersectionObserver';
import ComponentHeader from '../../../components/ComponentHeader/ComponentHeader';

const PartneredWithSection = () => {
  useIntersectionAnimate('.intersection-animate', 'animate', {
    threshold: 0.5,
  });

  return (
    <Container className='intersection-animate'>
      <ComponentHeader text='Partnered With' />
      <LogosContainer>
        <PartnerLogo src="/static/img/cml/mason-logo.png" alt="Mason Logo" />
        <PartnerLogo src="/static/img/cml/etairline-logo.png" alt="Ethiopian Airlines Logo" />
        <PartnerLogo src="/static/img/cml/ccl_logo.png" alt="CCL Confidence Cargo Limited Logo" />
      </LogosContainer>
    </Container>
  );
};

export default PartneredWithSection;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 20px;
  background-color: #ffffff;
  gap: 40px;

  @media (max-width: 768px) {
    padding: 55px 24px;
  }
`;


const LogosContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 60px;
  max-width: 1000px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 40px;
  }

  @media (max-width: 480px) {
    display: grid;
    align-items: end;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
  }

`;

const PartnerLogo = styled.img`
  max-width: 180px;
  height: auto;
  object-fit: contain;
  // filter: grayscale(100%);
  // opacity: 0.7;
  transition: all 0.3s ease-in-out;

  &:hover {
    filter: grayscale(0%);
    opacity: 1;
  }

  @media (max-width: 768px) {
    max-width: 150px;
  }

  @media (max-width: 480px) {
    max-width: 105px;
    width: 100%;
  }
`;